import { CircularProgress, Switch, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { adminCreateBooking, getScheduledCohorts } from '../../../services/apiService';
// import SelectCoach from './SelectCoach';
import CoachSelection from '../../../components/cohort/components/CoachSelection';
import SelectSessionDateTime from './_components/SelectSessionDateTime';
import SelectStudent from './_components/SelectStudent';
import SelectSubTopic from './_components/SelectSubTopic';
import SelectTheme from './_components/SelectTheme';

export default function AddNewBooking() {
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [selectedSubTopic, setSelectedSubTopic] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [deductCredits, setDeductCredits] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDirectBooking, setIsDirectBooking] = useState(false);
  const [selectedCohort, setSelectedCohort] = useState(null);
  const [cohortOptions, setCohortOptions] = useState([]);

  useEffect(() => {
    getScheduledCohorts({ status: 'scheduled', limit: 100 })
      .then((res) => setCohortOptions(res?.rows ?? []))
      .catch(console.error);
  }, []);

  const handleAddBooking = async () => {
    setIsLoading(true);
    try {
      const payload = {
        studentId: selectedStudent.id,
        subTopicId: selectedSubTopic.id,
        themeId: selectedTheme.id,
        deductUserCredits: deductCredits,
      };
      if (selectedCohort) {
        payload.cohortId = selectedCohort.id;
      }
      if (isDirectBooking) {
        payload.coachId = selectedCoach.id;
        payload.startTime = selectedDateTime.toISOString();
        payload.isDirectBooking = true;
      } else if (selectedCoach) {
        payload.exclusiveCoach = selectedCoach.id;
      }
      await adminCreateBooking(payload);
      toast.success('Booking successful');
      setSelectedTheme(null);
      setSelectedSubTopic(null);
      setSelectedStudent(null);
      setDeductCredits(false);
      setIsDirectBooking(false);
      setSelectedCoach(null);
      setSelectedCohort(null);
    } catch (err) {
      console.error(err);
      toast.error('Booking failed - ' + err?.response?.data?.message);
    }
    setIsLoading(false);
  };

  const disabled = useMemo(
    () => !(selectedTheme && selectedSubTopic && selectedStudent),
    [selectedTheme, selectedSubTopic, selectedStudent]
  );

  return (
    <div className='bg-gray-c2 p-8 font-medium'>
      <header className='flex'>
        <h1 className='text-3xl font-semibold ml-2'>Add New Booking</h1>
      </header>

      <SelectTheme
        selectedTheme={selectedTheme}
        setSelectedTheme={setSelectedTheme}
      />

      {selectedTheme && (
        <SelectSubTopic
          selectedTheme={selectedTheme}
          selectedSubTopic={selectedSubTopic}
          setSelectedSubTopic={setSelectedSubTopic}
        />
      )}

      {selectedSubTopic && (
        <SelectStudent
          selectedStudent={selectedStudent}
          setSelectedStudent={setSelectedStudent}
          deductCredits={deductCredits}
          setDeductCredits={setDeductCredits}
        />
      )}

      {selectedStudent && (
        <div className='mt-8 max-w-2xl'>
          <Autocomplete
            options={cohortOptions}
            getOptionLabel={(option) => option.name}
            onChange={(_, value) => setSelectedCohort(value)}
            value={selectedCohort}
            renderInput={(params) => (
              <TextField {...params} label='Scheduled Cohort (optional)' variant='outlined' />
            )}
          />
        </div>
      )}

      {selectedStudent && (
        <div className='mt-8 flex items-center gap-2'>
          <Switch
            checked={isDirectBooking}
            onChange={() => setIsDirectBooking(!isDirectBooking)}
            color='primary'
          />
          <span>Direct Booking</span>
        </div>
      )}

      {selectedStudent && (
        <CoachSelection
          coach={selectedCoach}
          setCoach={setSelectedCoach}
          label={isDirectBooking ? 'Coach' : 'Exclusive Coach'}
        />
      )}

      {isDirectBooking && (
        <SelectSessionDateTime
          selectedDateTime={selectedDateTime}
          setSelectedDateTime={setSelectedDateTime}
        />
      )}

      <button
        onClick={handleAddBooking}
        disabled={disabled}
        className={`mt-8 py-2 w-full max-w-md bg-green-c1 text-white font-medium rounded focus:outline-none ${
          disabled && 'opacity-50 cursor-default'
        }`}
      >
        {isLoading ? (
          <CircularProgress color='inherit' size='1.5rem' className='-my-1.5' />
        ) : (
          <span>ADD BOOKING</span>
        )}
      </button>
    </div>
  );
}
